import { render, staticRenderFns } from "./tab-service-report.vue?vue&type=template&id=0154cc8a&"
import script from "./tab-service-report.vue?vue&type=script&lang=js&"
export * from "./tab-service-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports